import React from "react";
import LargeButton from "../../elements/LargeIconButton";
import '../../styles/Filters/Filters.scss'
import {useDispatch} from 'react-redux';
import {active, compareActive, hasBeenLoaded } from '../../redux/Filters'

function Compare (){

    // const categories = [
    //     {id: '1', title: 'Countries', data : ['US', 'Canada', 'Mexico', 'Guatemala', 'Belize']},
    //     {id: '2', title: 'Age Group that has a very long title', data: ['18-34', '35-50', '50+']},
    //     {id: '3', title: 'Parent Status', data: ['Parent', 'Not a parent']},
    //     {id: '4', title: 'Genderreallylongwordthatisntbroken', data: ['Male', 'Female']}
    // ]

    const dispatch = useDispatch();

    // const isActive = useSelector((state) => state.showFilters.isActive)
    const closeSideNav = () =>{
        dispatch(active())
        dispatch(compareActive(false))
        dispatch(hasBeenLoaded())
    }

    const removeActive = () => {
        document.getElementById('comparison').querySelectorAll('div').forEach(btn => btn.classList.remove('button-gradient'))
    }

    const clickHandler = (e) => {
        removeActive()
        e.currentTarget.classList.add('button-gradient')
    }

    return(
            <div className="filters">
                <div className=" p-2 d-flex justify-content-between filter-header diagonal-stripes align-items-center">
                    <div className="bold px-2">Compare</div>
                    <div className='close-filter bold fs-5 p-1' onClick={closeSideNav}>X</div>
                </div>
                <div className='d-flex flex-wrap justify-content-around ' id='comparison'>
                    <LargeButton onClick={clickHandler} src='3M_countries.svg' alt='icon of globe'>Countries</LargeButton>
                    <LargeButton onClick={clickHandler} src='3M_agegroups_gray.svg' alt='icon of two people'>Age Group</LargeButton>
                    <LargeButton onClick={clickHandler} src='3M_gender.svg' alt='icon of two people'>Gender</LargeButton>
                    <LargeButton onClick={clickHandler} src='3M_education.svg' alt='icon of graduation'>Education</LargeButton>
                    {/* <LargeButton onClick={clickHandler}>Stem vs Non Stem </LargeButton> */}
                    {/* <LargeButton onClick={clickHandler}>Parents vs Nonparents</LargeButton> */}
                    {/* <LargeButton onClick={clickHandler}>Gender</LargeButton> */}
                    <LargeButton onClick={clickHandler}>Income</LargeButton>
                    <LargeButton onClick={clickHandler}>Location Type</LargeButton>
                    <LargeButton onClick={clickHandler}>Emerging vs Developed Countries</LargeButton>
                    <LargeButton onClick={clickHandler}>Employment</LargeButton>
                </div>
            </div>
    )
}

export default Compare